<template>
  <div class="table-container">
    <div class="table-column" v-for="stat in stats" :key="stat.val">
      <div class="table-head" v-html="stat.title"></div>
      <div class="table-description" v-html="stat.value"></div>
    </div>
  </div>
</template>

<script>
    export default {
        name: "DescriptionTable",
        props: {
          stats: Array
        }
    }
</script>

<style lang="stylus" scoped>
  @import '../../styles/tools'
  .table
    &-container
      color $white
      display flex
      flex-direction column
      @media (min-width: 600px)
        flex-direction row

    &-column
      display flex
      flex-direction column
      @media (min-width: 600px)
        width 50%

    &-head
      font-size 13px
      letter-spacing 1.3
      text-align left
      margin-bottom 2px
      @media (min-width: 600px) and (max-width: 768px)
        width-between-property 'font-size' 600 13 768 18 true true
      @media (min-width: 768px)
        font-size 18px


    &-description
      font-size 24px
      margin-bottom 20px
      @media (min-width: 600px) and (max-width: 768px)
        width-between-property 'font-size' 600 24 768 40 true true
      @media (min-width: 768px)
        font-size 40px

    &-value
      font-size 11px
      @media (min-width: 600px) and (max-width: 768px)
        width-between-property 'font-size' 600 11 768 23 true true
      @media (min-width: 768px)
        font-size 23px


</style>